import React, { useState } from 'react';
import teamService from '../services/teamService';
import { useNavigate } from 'react-router-dom';

const CreateTeam = () => {
  const [name, setName] = useState('');
  const [sportType, setSportType] = useState('FOOTBALL');
  const [badgePath, setBadgePath] = useState('');
  const [sportDbApiId, setSportDbApiId] = useState(0);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newTeam = {
      name,
      sportType,
      badgePath,
      sportDbApiId
    };

    try {
      await teamService.createTeam(newTeam);
      alert('Team created successfully!');
      navigate('/teams');
    } catch (err) {
      setError('Failed to create team');
      console.error(err);
    }
  };

  return (
    <div>
      <h2>Create New Team</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <form onSubmit={handleSubmit}>
        <div>
          <label>Team Name: </label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div>
          <label>Sport Type: </label>
          <select
            value={sportType}
            onChange={(e) => setSportType(e.target.value)}
            required
          >
            <option value="FOOTBALL">Football</option>
            <option value="HOCKEY">Hockey</option>
          </select>
        </div>
        
        <div>
          <label>Badge Path: </label>
          <input
            type="text"
            value={badgePath}
            onChange={(e) => setBadgePath(e.target.value)}
            required
          />
        </div>
        
        <div>
          <label>SportDB API ID: </label>
          <input
            type="number"
            value={sportDbApiId}
            onChange={(e) => setSportDbApiId(e.target.value)}
            required
          />
        </div>

        <button type="submit">Create Team</button>
      </form>
    </div>
  );
};

export default CreateTeam;
